export enum NavState {
  DEFAULT = 'default',
  BOOKING = 'booking',
  RESULTS = 'results',
}
